import { __assign } from "tslib";
import React from 'react';
import { Column } from '../../components/column';
import { Text } from '../../components/text';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { addBorderClasses } from './common';
import FooterLink from './footer-link';
var ContactsSection = function (_a) {
    var address = _a.address, isVisible = _a.isVisible, phone = _a.phone, showBorderLeft = _a.showBorderLeft, showBorderRight = _a.showBorderRight, width = _a.width, textColor = _a.textColor, paddingLeft = _a.paddingLeft, paddingRight = _a.paddingRight, isRtl = _a.isRtl;
    var style = {
        display: 'block',
        maxHeight: '100px',
    };
    return isVisible ? (React.createElement(Column, { cssClass: "html-emails-footer-section ".concat(addBorderClasses({
            showBorderRight: showBorderRight,
            showBorderLeft: showBorderLeft,
            isRtl: isRtl,
        }), " bigger-column-height ").concat(mobileFullWidthColumnClassName), direction: isRtl ? 'rtl' : 'ltr', verticalAlign: "middle", width: width, paddingRight: paddingRight, paddingLeft: paddingLeft },
        React.createElement(Text, { align: "center", lineHeight: "17px", cssClass: "html-emails-footer-business-details-with-mobile-divider", padding: "0px 10px 0px 10px" },
            React.createElement(FooterLink, __assign({ style: style }, address, { textColor: textColor })),
            React.createElement(FooterLink, __assign({ style: style }, phone, { textColor: textColor }))))) : null;
};
export var FooterBusinessDetails = ContactsSection;
//# sourceMappingURL=footer-business-details.js.map